import React from 'react';
import { Button, message, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import Request from 'common/network/Request';
import potentialCandidateApis from 'modules/dashboard/api/potential-candidate';

const DeleteCandidateButton = ({ record, onDeleteSuccess }) => {
  const [loading, setLoading] = React.useState(false);

  const confirm = async () => {
    setLoading(true);
    try {
      const response = await Request.post(
        potentialCandidateApis.delete_candidate,
        {
          id: record.id,
        },
      );

      if (response && response?.success) {
        message.success(response?.message || 'Xoá ứng viên thành công.');
        if (typeof onDeleteSuccess === 'function') {
          onDeleteSuccess();
        }
      } else {
        message.error(
          response?.message || 'Có lỗi xảy ra, vui lòng thử lại sau!',
        );
      }
    } catch (error) {
      message.error('Có lỗi xảy ra, vui lòng thử lại sau!');
    }
    setLoading(false);
  };

  return (
    <Popconfirm
      title="Xoá ứng viên này?"
      description={
        <div>
          <p>
            <b>{record?.name}</b> sẽ bị xoá khỏi hệ thống.
          </p>
          <p>Hãy chắc chắn bạn muốn thực hiện hành động này.</p>
          <p className="bold">
            <i>Lưu ý:</i> Hành động này không thể hoàn tác.
          </p>
        </div>
      }
      onConfirm={confirm}
      okText="Xoá"
      cancelText="Hủy"
      okType="danger"
      okButtonProps={{ loading }}
    >
      <Button danger block icon={<DeleteOutlined />} loading={loading}>
        Delete
      </Button>
    </Popconfirm>
  );
};

export default DeleteCandidateButton;
